import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TeamSessionsSection from "./TeamSessionsSection";
import TeamActivitySection from "./TeamActivitySection";

const TABS = [
  { key: "sessions", labelKey: "team.feedCard.sessions" },
  { key: "activity", labelKey: "team.feedCard.activity" },
];

/**
 * Sessions and Recent Activity in one card, one at a time. Both lists render
 * at their natural height (no internal cap) — the pane around them scrolls.
 * Both sections stay mounted so switching back is instant and nothing
 * refetches.
 */
const TeamFeedCard = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("sessions");

  return (
    <div className="rounded-xl border border-[#F3F4F6] bg-white">
      <div className="px-4 pt-4">
        <div className="flex items-center gap-1 rounded-lg bg-[#F3F4F6] p-0.5">
          {TABS.map((item) => (
            <button
              key={item.key}
              onClick={() => setTab(item.key)}
              className={`flex-1 rounded-md px-3 py-1.5 text-xs font-medium transition duration-150 ${
                tab === item.key
                  ? "bg-white text-[#111827] shadow-sm"
                  : "text-[#6B7280] hover:text-[#374151]"
              }`}
            >
              {t(item.labelKey)}
            </button>
          ))}
        </div>
      </div>
      <div hidden={tab !== "sessions"}>
        <TeamSessionsSection embedded />
      </div>
      <div hidden={tab !== "activity"}>
        <TeamActivitySection embedded />
      </div>
    </div>
  );
};

export default TeamFeedCard;
